import Occasions from "./Components/Occasions"
import './Css/form.css';
import {useState} from 'react';
import BasicData from "./Components/BasicData";
import Activities from "./Components/Activities";
import Total from "./Components/Total";
import Extras from "./Components/Extras";
import Location from "./Components/Location";
import {getTomorrowFormat} from "./Components/assets/PieDate";
import Submit, {Domain} from "./Components/Submit";
import PersonalData from "./Components/PersonalData";

export default function App() {

    const [formData, setFormData] = useState({});

    if (!Object.keys(formData).length) {
        fetch(Domain() + '?api=eventsform', {
            referrer: Domain()
        })
            .then((response) => response.json())
            .then((data) => {
                setFormData(data)
            });
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const [form, setForm] = useState({
        attendants: urlParams.get('attendants') ?? 10,
        date: urlParams.get('date') ?? getTomorrowFormat(),
        occasionId: urlParams.get('occasionId') ?? 0,
        activity: urlParams.get('activity') ?? 0,
        deal: urlParams.get('deal') ?? 0,
        dealPrice: urlParams.get('dealPrice') ?? 0,
        time: urlParams.get('time') ?? '8:00',
        extra: urlParams.get('extra') ? urlParams.get('extra').split(",") : [],
        extraPrice: urlParams.get('extraPrice') ? urlParams.get('extraPrice').split(",") : [],
        extraPriceAtt: urlParams.get('extraPriceAtt') ? urlParams.get('extraPriceAtt').split(",") : [],
        location: 'ownLocation',
        comment: '',
    });

    //console.log(form)

    const setData = (data = {}) => {
        setForm({...form, ...data});
    }

    //const mydump = (arr, level = 0) => {
    //    let dumped_text = [];
    //    if (!level) level = 0;
//
    //    let level_padding = "";
    //    for (let j = 0; j < level + 1; j++) level_padding += "    ";
//
    //    if (typeof (arr) == 'object') {
    //        for (let item in arr) {
    //            let value = arr[item];
//
    //            if (typeof (value) == 'object') {
    //                dumped_text.push({
    //                    title: level_padding + "'" + item + "' ",
    //                    value: mydump(value, level + 1)
    //                });
    //            } else {
    //                dumped_text.push({
    //                    title: level_padding + "'" + item + "'",
    //                    value: value
    //                });
    //            }
    //        }
    //    } else {
    //        dumped_text.push("===>" + arr + "<===(" + typeof (arr) + ")\\r\\n");
    //    }
    //    return dumped_text.map((item, index) =>
    //        <tr key={'dump_' + index}>
    //            <td>{item.title}</td>
    //            <td>{item.value}</td>
    //        </tr>);
    //}

    if (Object.keys(formData).length === 0) {
        return (<div>Loading...</div>);
    } else {
        return (
            <div className={'teamevents'}>
                <div className={'teamevents_form'} style={{display: 'flex'}}>
                    <div className="App" style={{width: '70%', float: 'left', flex: '3'}}>
                        <h2>1: Describe the occasion</h2>
                        <div className="occasion_bg">
                            <div className="occasion">
                                <Occasions setData={setData} form={form} occasions={formData.occasions}/>
                                <div style={{clear: 'both'}}></div>
                            </div>
                        </div>
                        <h2>2: NUMBER OF ATTENDEES</h2>
                        <div className="basic_data_bg">
                            <div className="basic_data">
                                <BasicData setData={setData} form={form}/>
                                <div style={{clear: 'both'}}></div>
                            </div>
                        </div>
                        <h2>3: Select an activity</h2>
                        <div className="activity">
                            <Activities setData={setData} form={form} activities={formData.activities}/>
                            <div style={{clear: 'both'}}></div>
                        </div>
                        <h2>5: Spice it all up (select add-ons)</h2>
                        <div className="extra_bg">
                            <div className="extra">
                                <Extras setData={setData} form={form} extras={formData.extras}/>
                            </div>
                        </div>
                        <h2>6: Location</h2>
                        <div className="location_bg">
                            <div className="location">
                                <Location setData={setData} form={form}/>
                                <div style={{clear: 'both'}}></div>
                            </div>
                        </div>
                    </div>
                    <div className="dashboard" style={{
                        padding: '10px',
                        flex: '1'
                    }}>
                        <div className="sticky">
                            <div className="total">
                                <Total form={form} ownLocations={formData?.ownLocations ?? {}}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="personal_data_bg">
                    <PersonalData setData={setData} form={form}/>
                    <div className={'clear'}></div>
                    <div className="total">
                        <Submit form={form}/>
                    </div>
                </div>
            </div>
        );
    }
}
